module.exports = __webpack_public_path__ + "static/img/product-CARS-2.43a34ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/product-CARS-2.png
// module id = rdXg
// module chunks = 13